module.exports = __webpack_public_path__ + "static/img/store.593f92d4.svg";